<script lang="ts">
	import { allergensDataMap } from "../../../../core/schema/allergensDataMap.js";
	import type { Allergen } from "../../../../core/schema/Allergen.js";

	export let allergens: Allergen[];
</script>

<div class="mt-8 flex flex-col gap-3">
	{#if allergens.length > 0}
		<p class="font-semibold leading-6">Alergeny</p>
		<div class="flex flex-wrap gap-2">
			{#each allergens as allergen}
				{@const allergenData = allergensDataMap[allergen]}
				<span
					class="text-2xs border-secondary flex h-[1.3125rem] w-[1.3125rem] items-center justify-center rounded-full border font-semibold leading-3"
				>
					{allergenData.orderLabel}
				</span>
			{/each}
		</div>
	{/if}
</div>
